import script from "./npsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./npsRow.vue?vue&type=script&setup=true&lang=js"

import "./npsRow.vue?vue&type=style&index=0&id=2cb64828&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb64828"]])

export default __exports__